import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { InventoryProvider } from './context/InventoryContext';
import { LanguageProvider } from './context/LanguageContext';
import { CatalogProvider } from './context/CatalogContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';

// Handle errors gracefully
window.addEventListener('unhandledrejection', (event) => {
  console.error('Error:', event.reason?.message || event.reason);
  event.preventDefault();
});

window.addEventListener('error', (event) => {
  console.error('Error:', event.error?.message || event.error);
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <CatalogProvider>
          <InventoryProvider>
            <App />
          </InventoryProvider>
        </CatalogProvider>
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Register service worker for offline support
serviceWorkerRegistration.register();
